/* Option B nav
   Desktop: mega panels + Help dropdown with hover intent (small open/close delay),
   keyboard focus, Escape, outside click and first-tap-opens on touch.
   Mobile: drill-down levels inside the Impulse #NavDrawer (open/close of the
   drawer itself stays with Impulse's own drawer script). */
(function () {
  if (window.__optbNav) return;
  window.__optbNav = true;

  var OPEN_DELAY = 120;
  var CLOSE_DELAY = 200;

  function initDesktop() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-optb-item]'));
    if (!items.length) return;

    var openItem = null;
    var lastPointer = 'mouse';

    document.addEventListener('pointerdown', function (evt) {
      lastPointer = evt.pointerType || 'mouse';
    }, true);

    function setState(item, isOpen) {
      var trigger = item.querySelector('[data-optb-trigger]');
      item.classList.toggle('is-open', isOpen);
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function open(item) {
      if (openItem && openItem !== item) setState(openItem, false);
      openItem = item;
      setState(item, true);
    }

    function close(item) {
      setState(item, false);
      if (openItem === item) openItem = null;
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-optb-trigger]');
      var panel = item.querySelector('[data-optb-panel]');
      if (!trigger || !panel) return;
      var timer = null;
      var skipFocusOpen = false;

      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { open(item); }, openItem ? 0 : OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (!item.contains(document.activeElement) || lastPointer !== 'keyboard') close(item);
        }, CLOSE_DELAY);
      });

      item.addEventListener('focusin', function () {
        if (skipFocusOpen) { skipFocusOpen = false; return; }
        clearTimeout(timer);
        open(item);
      });

      item.addEventListener('focusout', function (evt) {
        if (evt.relatedTarget && item.contains(evt.relatedTarget)) return;
        clearTimeout(timer);
        close(item);
      });

      item.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape' || evt.key === 'Esc') {
          if (!item.classList.contains('is-open')) return;
          evt.preventDefault();
          close(item);
          skipFocusOpen = true;
          trigger.focus();
        }
      });

      // Touch: first tap opens the panel, second tap follows the link.
      trigger.addEventListener('click', function (evt) {
        if (lastPointer === 'touch' || lastPointer === 'pen') {
          if (!item.classList.contains('is-open')) {
            evt.preventDefault();
            clearTimeout(timer);
            open(item);
          }
        }
      });
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Tab') lastPointer = 'keyboard';
    }, true);

    document.addEventListener('click', function (evt) {
      if (openItem && !openItem.contains(evt.target)) close(openItem);
    });

    // Close an open panel when the viewport switches to the mobile layout.
    var mq = window.matchMedia('(max-width: 768px)');
    var onChange = function () { if (mq.matches && openItem) close(openItem); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  function initMobile() {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer || !drawer.classList.contains('optb-drawer')) return;

    var root = drawer.querySelector('[data-optb-m-root]');
    var scroller = drawer.querySelector('.drawer__scrollable');
    var levels = Array.prototype.slice.call(drawer.querySelectorAll('[data-optb-level]'));
    var current = null;

    function showLevel(level, opener) {
      if (!level) return;
      root.hidden = true;
      levels.forEach(function (l) { l.hidden = l !== level; });
      opener.setAttribute('aria-expanded', 'true');
      current = { level: level, opener: opener };
      if (scroller) scroller.scrollTop = 0;
      var back = level.querySelector('[data-optb-level-close]');
      if (back) back.focus();
    }

    function showRoot(restoreFocus) {
      levels.forEach(function (l) { l.hidden = true; });
      root.hidden = false;
      if (current) {
        current.opener.setAttribute('aria-expanded', 'false');
        if (restoreFocus) current.opener.focus();
        current = null;
      }
      if (scroller) scroller.scrollTop = 0;
    }

    drawer.addEventListener('click', function (evt) {
      if (!evt.target || !evt.target.closest) return;
      var opener = evt.target.closest('[data-optb-level-open]');
      if (opener) {
        evt.preventDefault();
        showLevel(document.getElementById(opener.getAttribute('aria-controls')), opener);
        return;
      }
      if (evt.target.closest('[data-optb-level-close]')) {
        evt.preventDefault();
        showRoot(true);
      }
    });

    drawer.addEventListener('keydown', function (evt) {
      if ((evt.key === 'Escape' || evt.key === 'Esc') && current) {
        evt.stopPropagation();
        showRoot(true);
      }
    });

    // Always start at the top level when the menu drawer is opened again.
    document.addEventListener('click', function (evt) {
      if (evt.target && evt.target.closest && evt.target.closest('.js-drawer-open-nav')) showRoot(false);
    });
  }

  function init() {
    initDesktop();
    initMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();